import type { APIErrorType } from '@core/types';
import type { ComponentProps } from 'react';

import Flex from '@ui/Flex';
import Toast from '@ui/Toast';

export interface VersionNotificationProps extends ComponentProps<typeof Toast> {
  /**
   * When provided, API v2 error details are parsed and included in the
   * notification description.
   */
  apiError?: APIErrorType;
}

export default function VersionNotification({ apiError, description, ...rest }: VersionNotificationProps) {
  return (
    <Toast
      description={
        <Flex gap={3} layout="col">
          {apiError?.info?.errors?.map(error => (
            <span key={error.key}>{error.message.endsWith('.') ? error.message : `${error.message}.`}</span>
          ))}

          <span>{description}</span>
        </Flex>
      }
      theme="dark"
      {...rest}
    />
  );
}
